import React, {useEffect, useRef, useState} from 'react';

export const LIVE_LINES = [
  ['https://play3833366.is-spec.com/live/mosixmark.flv', 'https://play8888.88888lhc.com/live/mosixmark.flv', 'https://play666.macau-lhc.live/live/mosixmark.flv', 'https://live-macaujc.com/live/livestream/new.flv'],
  ['https://play8882.ksrd365.com/live/mosixmark.flv'],
  ['https://play8398.lianwin88.com/live/mosixmark.flv'],
];

export function MacauLivePlayer({line}) {
  const video = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [hint, setHint] = useState('暂无直播画面，正在等待信号…');
  useEffect(() => {
    let stopped = false, player, retryTimer, timeout, attempt = 0;
    const element = video.current;
    const dispose = () => { clearTimeout(timeout); player?.destroy(); player = null; };
    const retry = () => {
      if (stopped || retryTimer) return;
      setPlaying(false);
      setHint('暂无直播画面，正在等待信号…');
      retryTimer = setTimeout(() => { retryTimer = null; start(); }, 15000);
      dispose();
    };
    const onPlaying = () => { clearTimeout(timeout); setPlaying(true); };
    const onWaiting = () => {
      setPlaying(false);
      setHint('画面缓冲中，正在等待信号…');
      clearTimeout(timeout);
      timeout = setTimeout(retry, 20000);
    };
    async function start() {
      try {
        const {default: mpegts} = await import('mpegts.js');
        if (stopped) return;
        if (!mpegts.getFeatureList().mseLivePlayback) {
          setHint('当前浏览器不支持此线路，请切换动画直播。');
          return;
        }
        const urls = LIVE_LINES[line];
        player = mpegts.createPlayer({type: 'flv', isLive: true, url: urls[attempt++ % urls.length]}, {enableWorker: false, liveBufferLatencyChasing: true});
        player.on(mpegts.Events.ERROR, retry);
        player.attachMediaElement(element);
        player.load();
        timeout = setTimeout(retry, 20000);
        const playback = player.play();
        playback?.catch(error => { if (!stopped && error.name === 'NotAllowedError') setHint('请点击播放器的播放按钮开始观看。'); });
      } catch { retry(); }
    }
    element.addEventListener('playing', onPlaying);
    element.addEventListener('waiting', onWaiting);
    element.addEventListener('ended', retry);
    element.addEventListener('error', retry);
    start();
    return () => {
      stopped = true;
      clearTimeout(retryTimer);
      element.removeEventListener('playing', onPlaying);
      element.removeEventListener('waiting', onWaiting);
      element.removeEventListener('ended', retry);
      element.removeEventListener('error', retry);
      dispose();
    };
  }, [line]);
  return <div className="macau-live-stage">
    <video ref={video} controls autoPlay muted playsInline aria-label="新澳门六合彩视频直播"/>
    {!playing && <div className="macau-live-placeholder" role="status"><p>新澳门六合彩搅珠直播时间为每晚<strong>21:30–21:38</strong>，敬请查看。</p><small>{hint}</small></div>}
  </div>;
}
